/**
 * Catálogo base (es). Es la fuente de la forma: `en` tiene que tener exactamente las mismas
 * claves (lo verifica el tipo `Catalog` y un test).
 */
export const es = {
  app: {
    name: 'worldSim2',
    tagline: 'Simulador de historia emergente',
  },
  placeholder: {
    title: 'La casa está lista',
    body: 'Fase 0: fundaciones de arquitectura. Todavía no hay mundo que mirar.',
    engineVersion: 'Motor v{{version}}',
  },
  /** Mapa v1 (P1.2): estado de la carga, relleno de prueba y lo que hay bajo el mouse. */
  map: {
    status: {
      starting: 'Preparando el mapa…',
      generating: 'Generando el mundo: {{stage}} ({{index}} de {{total}})',
      ready:
        'Semilla {{seed}} · mundo {{size}} · {{provinces}} provincias · {{backend}} · listo en {{seconds}} s',
      error: 'No se pudo mostrar el mapa: {{message}}',
    },
    stage: {
      plates: 'placas',
      relief: 'relieve',
      erosion: 'erosión',
      climate: 'clima',
      hydrology: 'ríos y lagos',
      biomes: 'biomas',
      provinces: 'provincias',
      seas: 'mares',
      graph: 'caminos',
      hash: 'verificación',
    },
    backend: {
      webgpu: 'WebGPU',
      webgl2: 'WebGL2',
      webgl2Forced: 'WebGL2 (forzado)',
    },
    colors: {
      label: 'Relleno',
      political: 'Político',
      biome: 'Bioma dominante',
      id: 'Un color por provincia',
      none: 'Sin relleno',
    },
    hover: {
      province: 'Provincia {{id}}',
      area: '{{area}} km²',
      ocean: 'Océano',
      lake: 'Lago',
    },
    selected: 'Seleccionada: provincia {{id}}',
    help: 'Arrastrar para mover · rueda para acercar · Q y E para girar · clic para seleccionar',
  },
  live: {
    status: {
      starting: 'Preparando la simulación…',
      year: '{{year}} · {{era}}',
      waiting: 'esperando a la simulación',
      ahead: 'simulado hasta {{year}}',
      finished: 'fin de la corrida',
      viewOnly:
        'Historia guardada con la versión {{version}} del motor: se puede mirar, no continuar',
      cost: '{{ms}} ms por año simulado',
      error: 'La simulación falló: {{message}}',
    },
    entity: {
      none: 'tierra libre',
      warBetween: 'guerra entre {{attacker}} y {{defender}}',
      fallback: {
        province: 'provincia {{id}}',
        settlement: 'asentamiento {{id}}',
        polity: 'estado {{id}}',
        person: 'persona {{id}}',
        culture: 'cultura {{id}}',
        war: 'guerra {{id}}',
      },
    },
    speed: {
      label: 'Velocidad',
      pause: 'Pausa',
      x1: '1×',
      x2: '2×',
      x4: '4×',
      max: 'Máx.',
    },
    timeline: {
      label: 'Línea de tiempo: hacé clic o arrastrá para ir a otro año',
    },
    saves: {
      save: 'Guardar',
      saving: 'Guardando…',
      saved: 'Guardado hasta {{year}}',
      title: 'Mundos guardados',
      empty: 'Todavía no hay mundos guardados.',
      item: 'Semilla {{seed}} · {{size}} · hasta {{year}}',
      load: 'Cargar',
      remove: 'Borrar',
      loading: 'Cargando el mundo guardado…',
      notFound: 'No se encontró el mundo guardado {{id}}.',
      error: 'No se pudo guardar: {{message}}',
    },
  },
  ui: {
    create: {
      title: 'Crear mundo',
      params: 'Parámetros del mundo',
      seed: 'Semilla',
      seedHint: 'número o texto',
      random: 'Aleatoria',
      size: 'Tamaño',
      sizeHint: '{{provinces}} provincias',
      mapType: 'Tipo de mapa',
      land: 'Fracción de tierra',
      landHint: 'El valor por defecto depende del tipo de mapa.',
      generate: 'Generar mundo',
      generating: 'Generando: {{stage}} · etapa {{index}} de {{total}}',
      error: 'No se pudo generar el mundo: {{message}}',
      retry: 'Reintentar',
    },
    saves: {
      title: 'Mundos guardados (este navegador)',
      empty: 'Todavía no hay mundos guardados.',
      world: 'Semilla {{seed}} · {{size}} · {{mapType}}',
      worldColumn: 'Mundo',
      until: 'Hasta',
      savedAt: 'Guardado',
      load: 'Cargar',
      export: 'Exportar',
      remove: 'Borrar',
      import: 'Importar .wsim…',
      importError: 'No se pudo importar: {{message}}',
      viewOnly: 'solo para mirar (motor {{version}})',
    },
    world: {
      label: 'Semilla {{seed}} · {{size}} · {{mapType}}',
      summary: 'Resumen',
      export: 'Exportar',
      back: 'Volver a la vista en vivo',
      generating: 'Generando el mundo: {{stage}} ({{index}} de {{total}})',
      preparingMap: 'Preparando el mapa…',
      mapError: 'No se pudo mostrar el mapa: {{message}}. La simulación sigue.',
      error: 'No se pudo abrir el mundo: {{message}}',
      retry: 'Reintentar',
      create: 'Crear otro mundo',
      shortcuts:
        'Atajos: espacio pausa · ←/→ ±100 años · 1–4 velocidades · Esc cierra el inspector',
    },
    share: {
      button: 'Compartir',
      title: 'Compartir este mundo',
      hint: 'El link regenera el mismo mundo y su historia con la misma versión del motor ({{version}}).',
      copy: 'Copiar',
      copied: 'Link copiado',
      copyFailed: 'No se pudo copiar: seleccioná el link y copialo a mano.',
      close: 'Cerrar',
      worldHash: 'Huella del mundo',
      finalHash: 'Huella final ({{year}})',
      computeFinal: 'Calcular la huella final',
      notFinished: 'La corrida todavía no terminó: la huella final aparece al llegar a 1900.',
    },
    shared: {
      running: 'Simulando la historia del link: {{year}} · {{pct}} %',
      done: 'Historia lista: {{years}} años simulados.',
      play: 'Reproducir desde el principio',
      finalHash: 'Huella final: {{hash}}',
      versionMismatch:
        'Este link es de la versión {{link}} del motor y esta es la {{engine}}: el mundo y su historia pueden ser distintos.',
    },
    rail: {
      mapMode: 'Modo de mapa',
      legend: 'Leyenda',
      legendPolity: 'un color por estado',
      legendNoOwner: 'sin color: sin dueño',
      legendSettlements: 'puntos: aldea → metrópolis',
    },
    inspector: {
      title: 'Inspector',
      atDate: 'a la fecha: {{year}}',
      empty: 'Hacé clic en el mapa o en un evento para inspeccionar.',
      close: 'Cerrar',
      back: 'Atrás',
      open: 'Abrir ficha',
      notYet: 'Todavía no existe a esta fecha.',
      owner: 'Dueño',
      settlement: 'Asentamiento',
      population: 'Población',
      urban: 'urbana {{pct}} %',
      culture: 'Cultura mayoritaria',
      knows: 'Conoce',
      nothing: 'nada todavía',
      founded: 'Fundación',
      ended: 'Fin',
      active: 'activo',
      endReason: {
        active: 'activo',
        absorbed: 'absorbido por otro estado',
        conquered: 'conquistado',
      },
      capital: 'Capital',
      provinces: 'Provincias',
      ruler: 'Gobernante',
      heir: 'Heredero',
      rulers: 'Gobernantes',
      wars: 'Guerras',
      born: 'Nacimiento',
      died: 'Muerte',
      alive: 'vive',
      age: '{{age}} años',
      parents: 'Padres',
      ruled: 'Gobernó',
      language: 'Idioma',
      origin: 'Origen',
      majority: 'Mayoría en {{count}} provincias',
      attacker: 'Atacante',
      defender: 'Defensor',
      started: 'Inicio',
      outcome: 'Resultado',
      level: 'Nivel',
      province: 'Provincia',
      none: '—',
      percent: '{{value}} %',
      more: '+{{count}} anteriores',
      warItem: '{{opponent}} ({{year}})',
      show: 'Mostrar',
      showAtDate: 'a la fecha ({{year}})',
      showFinal: 'al final',
      finalOnlyWhenDone: '(solo con la corrida terminada)',
      events: 'Eventos (con sus causas)',
      noEvents: 'Sin eventos hasta esta fecha.',
      cause: 'por: {{text}}',
    },
    why: {
      title: '¿Por qué? (estado exacto a la fecha)',
      compute: 'Calcular el porqué',
      computing: 'Calculando… (re-simulando desde el último keyframe)',
      at: 'calculado para {{year}} en {{ms}} ms',
      refresh: 'Actualizar a {{year}}',
      base: 'base',
      value: 'valor',
      modifier: 'modificador ({{source}})',
      cropShare: 'Tierra cultivada',
      foodSecurity: 'Alimento / necesidad',
      cultures: 'Población por cultura',
      notAvailable: 'Esta historia es de otra versión del motor: el porqué no se puede recalcular.',
      error: 'No se pudo calcular: {{message}}',
    },
    stat: {
      cropYield: 'Rendimiento del cultivo',
      forageYield: 'Rendimiento del forrajeo',
      cropReach: 'Tierra cultivable alcanzable',
      diffusionRate: 'Difusión del conocimiento',
      urbanShare: 'Fracción urbana base',
      combatStrength: 'Fuerza militar',
      reach: 'Alcance administrativo',
    },
    unit: {
      tons_per_year: 't por km² y año',
      per_year: 'por año',
      fraction: 'proporción',
      score: 'puntos',
      days: 'días',
    },
    kind: {
      province: 'Provincia',
      settlement: 'Asentamiento',
      polity: 'Estado',
      person: 'Personaje',
      culture: 'Cultura',
      war: 'Guerra',
    },
    kinds: {
      polity: 'Estados',
      settlement: 'Asentamientos',
      culture: 'Culturas',
      person: 'Personajes',
      war: 'Guerras',
    },
    outcome: {
      ongoing: 'en curso',
      attackerVictory: 'victoria del atacante',
      defenderVictory: 'victoria del defensor',
      whitePeace: 'paz sin cambios',
    },
    ticker: {
      title: 'Teletipo',
      empty: 'Todavía no pasó nada importante.',
    },
    summary: {
      until: 'Resumen hasta {{year}} (lo ya visto)',
      final: 'Panorama final',
      population: 'Población',
      polities: 'Estados activos',
      foundedTotal: 'fundados: {{count}}',
      wars: 'Guerras',
      settlements: 'Asentamientos',
      era: 'Era dominante',
      chartPopulation: 'Población mundial',
      chartPolities: 'Cantidad de estados',
      chartLargest: 'Mayor estado (personas)',
      empty: 'Nada hasta esta fecha.',
      rows: '{{count}} filas',
    },
    column: {
      name: 'Nombre',
      founded: 'Fundación',
      ended: 'Fin',
      provinces: 'Provincias',
      population: 'Población',
      capital: 'Capital',
      province: 'Provincia',
      level: 'Nivel',
      language: 'Idioma',
      majority: 'Provincias con mayoría',
      born: 'Nacimiento',
      died: 'Muerte',
      ruled: 'Gobernó',
      attacker: 'Atacante',
      defender: 'Defensor',
      started: 'Inicio',
      outcome: 'Resultado',
    },
  },
  time: {
    yearBC: '{{year}} a.C.',
    yearAD: '{{year}} d.C.',
  },
  language: {
    label: 'Idioma',
    es: 'Español',
    en: 'English',
  },
  /** Plantillas de eventos: `events.<clave del evento>` (las exige un test de @ws/sim). */
  events: {
    territory: {
      changed: '{{province}} pasa de {{from}} a {{to}}',
    },
    subsistence: {
      shifted: 'En {{province}} la agricultura ya alimenta a la mayoría',
    },
    famine: {
      started: 'Hambruna en {{province}}',
      ended: 'Termina la hambruna en {{province}}',
    },
    innovation: {
      invented: '{{innovation}} surge en {{province}}',
    },
    settlement: {
      founded: 'Se funda {{settlement}} en {{province}}',
      grew: '{{settlement}} crece: ahora es {{level}}',
      declined: '{{settlement}} decae: ahora es {{level}}',
    },
    polity: {
      formed: 'Nace {{polity}} en {{province}}',
      absorbed: '{{polity}} se integra a {{by}}',
      collapsed: '{{polity}} desaparece',
    },
    person: {
      died: 'Muere {{person}} a los {{age}} años',
    },
    ruler: {
      succeeded: '{{person}} gobierna {{polity}}',
    },
    war: {
      declared: '{{attacker}} declara la guerra a {{defender}}',
      ended: 'Termina la guerra entre {{attacker}} y {{defender}}',
    },
    treaty: {
      signed: 'Paz entre {{attacker}} y {{defender}}',
    },
    battle: {
      fought: 'Batalla en {{province}} entre {{attacker}} y {{defender}}',
    },
  },
  /** Nombres de las filas de contenido: `content.<tabla>.<clave>` (los exige un test). */
  content: {
    worldSize: { small: 'Chico', medium: 'Mediano' },
    mapType: { continents: 'Continentes', pangaea: 'Pangea', archipelago: 'Archipiélago' },
    biome: {
      ice: 'Hielo',
      alpine: 'Alpino',
      tundra: 'Tundra',
      taiga: 'Taiga',
      desert: 'Desierto',
      grassland: 'Pradera',
      temperateForest: 'Bosque templado',
      savanna: 'Sabana',
      tropicalForest: 'Selva tropical',
    },
    settlementLevel: {
      village: 'Aldea',
      town: 'Pueblo',
      city: 'Ciudad',
      greatCity: 'Gran ciudad',
      metropolis: 'Metrópoli',
    },
    innovation: {
      agriculture: 'Agricultura',
      pastoralism: 'Pastoreo',
      pottery: 'Cerámica',
      wheel: 'Rueda',
      copper: 'Metalurgia del cobre',
      plough: 'Arado',
      writing: 'Escritura',
      bronze: 'Bronce',
      iron: 'Hierro',
      coinage: 'Moneda acuñada',
      cropRotation: 'Rotación de cultivos',
      oceanNavigation: 'Navegación oceánica',
      printing: 'Imprenta',
      gunpowder: 'Pólvora',
    },
    era: {
      prehistory: 'Prehistoria',
      neolithic: 'Neolítico',
      bronzeAge: 'Edad del bronce',
      ironAge: 'Edad del hierro',
      earlyModern: 'Edad moderna temprana',
    },
    stratum: { common: 'Común' },
    law: { primogeniture: 'Primogenitura' },
  },
} as const;
